import styled from "styled-components";

// Used for wrapping a page component
export const Screen = styled.div`
  background-color: var(--primary);
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

// Used for providing space between components
export const SpacerXSmall = styled.div`
  height: 8px;
  width: 8px;
`;

// Used for providing space between components
export const SpacerSmall = styled.div`
  height: 16px;
  width: 16px;
`;

// Used for providing space between components
export const SpacerMedium = styled.div`
  height: 24px;
  width: 24px;
`;

// Used for providing space between components
export const SpacerLarge = styled.div`
  height: 32px;
  width: 32px;
`;

// Used for providing a wrapper around a component
export const Container = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
`;

export const TextTitle = styled.p`
  font-family: Verdana;
  color: var(--primary-text);
  font-size: 22px;
  font-weight: 1000;
  line-height: 1.3;
`;

export const SupplyTitle = styled.p`
  font-family: Verdana;
  color: var(--primary-text);
  font-size: 22px;
  font-weight: 500;
  line-height: 0.6;
  width: 250px;
`;



export const TextSubTitle = styled.p`
  color: var(--primary-text);
  font-size: 18px;
  line-height: 1.6;
`;

export const TextDescription = styled.p`
  font-family: Verdana;
  color: var(--secondary-text);
  font-weight: 1000;
  font-size: 20.5px;
  line-height: 0.6;
  letter-spacing: 0.2px;
`;
export const TextWDescription = styled.p`
  font-family: Verdana;
  color: var(--accent-text);
  font-size: 18px;
  font-weight: 5000%;
  line-height: 0.6;
  letter-spacing: 0px;
`;

export const TextCopyright = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 15px;
  line-height: 0.6;
  letter-spacing: 0.2px;
`;
export const TextPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 20px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;
export const TextGPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 15px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;
export const TextGFPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 15px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;
export const TextAPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 28px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;
export const TextTPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size: 48px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;
export const TextCPower = styled.p`
  font-family: Verdana;
  color: var(--socialtext);
  font-size:15px;
  line-height: 0.6;
  letter-spacing: 0.5px;
  word-spacing: 5px;
  font-weight: 1000;
`;

export const StyledClickable = styled.div`
  :active {
    opacity: 0.6;
  }
`;
export const TextBar = styled.p`
  font-family: Verdana;
  color: var(--primary-text);
  font-size: 30px;
  font-weight: 1000;
  line-height: 0.7;
`;
export const Textlogo = styled.p`
  font-family: Verdana;
  color: var(--textlogo);
  font-size: 40px;
  font-weight: 1000;
  line-height: 1;
`;
export const Socialtext = styled.p`
  font-family: Verdana;
  color: var(--textlogo);
  font-size: 20px;
  font-weight: 1000;
  line-height: 2.5;
`;